(function () {
    'use strict';
    angular
        .module('tikonApp')
        .factory('SelectorDataQuery', SelectorDataQuery);

    SelectorDataQuery.$inject = ['$resource', 'ENV'];

    function SelectorDataQuery($resource, ENV) {

        var findByType = function (type) {
            var resourceUrl = ENV.API_BASE_URL + 'api/selector-data-by-key/' + type;
            return $resource(resourceUrl, {}, {
                    'query': {method: 'GET', isArray: true}
                }
            );
        };
        ///client/selector-data-by-typeid/{typeid}
        var findByTypeId = function (typeid) {
            var resourceUrl = ENV.API_BASE_URL + 'api/client/selector-data-by-typeid/' + typeid;
            return $resource(resourceUrl, {}, {
                    'query': {method: 'GET', isArray: true}
                }
            );
        };
        var findByTypeAndParent = function (type, parent) {
            if (parent == null) parent = 0;
            var resourceUrl = ENV.API_BASE_URL + 'api/selector-data-by-key/' + type + '/' + parent;
            return $resource(resourceUrl, {}, {
                    'query': {method: 'GET', isArray: true}
                }
            );
        };


        return {
            findByType: findByType,
            findByTypeAndParent: findByTypeAndParent,
            findByTypeId: findByTypeId

        };
    }
})();
